import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PickerAddIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <>
                <path d="M0,0H2V14H0Z" transform="translate(6)" fill={color}/>
                <path d="M0,2V0H14V2Z" transform="translate(0 6)" fill={color}/>
            </>
        ]
    }
    getViewBox = () => '0 0 14 14'
}
